import type { LobCurrency } from "../features/lobConfig/LobConfigSlice";

// Amount with the LoB's symbol and digit grouping, e.g. "₹1,00,000.00" for
// INDIA or "RM100,000.00" for MALAYSIA. Pure so module-level formatters
// (outside React components) can use it with a currency they were handed.
export const formatMoney = (
  amount: number | string | null | undefined,
  currency: LobCurrency,
  options: Intl.NumberFormatOptions = { minimumFractionDigits: 2, maximumFractionDigits: 2 },
): string => {
  const n = Number(amount ?? 0);
  const safe = Number.isFinite(n) ? n : 0;
  return `${currency.symbol}${safe.toLocaleString(currency.locale, options)}`;
};

// Number grouped for the LoB's locale, without a symbol.
export const formatNumber = (
  amount: number | string | null | undefined,
  currency: LobCurrency,
  options?: Intl.NumberFormatOptions,
): string => {
  const n = Number(amount ?? 0);
  return (Number.isFinite(n) ? n : 0).toLocaleString(currency.locale, options);
};
